import IdeaX6Flow from "./index.vue";
import "./icons";
import * as graphFunc from "./functions.js";

const components = [IdeaX6Flow];

function install(Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export { IdeaX6Flow, graphFunc };

export default { install };
